// tslint:disable: completed-docs
// tslint:disable: interface-name

import { LoanType } from '@shared/enum';

export interface IConsumerInformation {
  id: string;
  firstName: string;
  lastName: string;
  consumerId: string;
  referenceFolderId: string;
  loanDocReferenceId: string[];
  loans: ConsumerLoan[];
  extraData: string;
  hostPrefillToken: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  oaoMemberInformation: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  olaApplicationInformation: any;
}

export interface ConsumerLoan {
  loanId: string;
  applicationId: string;
  application: ConsumerLoanApplication;
  loanInformation: QuickApp;
  loanNumber: string;
  lenderName: string;
  lenderId: string;
  tempLoanNumber: string;
}

export interface ConsumerLoanApplication {
  loanApplicationId: string;
  loanApplications: LoanApplication[];
}

export interface LoanApplication {
  primaryConsumerId: string;
  applicationStage: LoanApplicationStage;
}

export interface QuickApp {
  quickAppID: number;
  loanType: LoanType;
}

export enum LoanApplicationStage {
  Shopping = 'Shopping',
  Application = 'Application',
  PostApplication = 'PostApplication'
}
